import styled from '@emotion/styled'
import { placeholderAnimation } from '../components/placeholderAnimation'
import { breakpoint, calcRem, TheNightlyThemeConfig } from '../../../__styling'
import { textMixin } from '../../../mixins/TextMixin/TextMixin'
import { tokens } from '@news-mono/design-tokens'
import { partyColors } from '../data'

const { utility, neutral } = tokens.thenightly.colors.palette

export const StyledContainer = styled('div')(({ theme }) => ({
    width: '100%',
    margin: '0 auto',
    fontFamily: theme.fonts.sansSerif,
}))

export const StyledWrapper = styled('div')({
    position: 'relative',
    height: calcRem(46),
    display: 'flex',
    alignItems: 'flex-end',
    gap: calcRem(8),
    bottom: calcRem(2),
    [breakpoint('sm')]: {
        height: calcRem(52),
    },
})

export const StyledBarsContainer = styled('div')({
    position: 'relative',
    flex: 1,
    height: '100%',
})

export const StyledBackgroundBar = styled('div')({
    position: 'absolute',
    bottom: calcRem(2),
    left: 0,
    right: 0,
    height: calcRem(16),
    backgroundColor: neutral[20],
    zIndex: -1,
})

export const StyledPartyBar = styled('div')(
    (props: { width: number; isRight?: boolean }) => ({
        position: 'absolute',
        bottom: calcRem(2),
        ...(props.isRight ? { right: 0 } : { left: 0 }),
        height: 'auto',
        width: `${props.width}%`,
        display: 'flex',
        alignItems: 'flex-end',
        ...(props.isRight && { justifyContent: 'flex-end' }),
    }),
)

export const StyledBarContent = styled('div')({
    width: '100%',
    height: calcRem(16),
    display: 'flex',
})

export const StyledWonSeats = styled('div')(
    (props: { partyType: 'coalition' | 'labor'; width: number }) => ({
        backgroundColor:
            props.partyType === 'coalition'
                ? partyColors.COL.dark
                : partyColors.ALP.dark,
        width: `${props.width}%`,
    }),
)

export const StyledPredictedSeats = styled('div')(
    (props: { partyType: 'coalition' | 'labor'; width: number }) => ({
        backgroundColor:
            props.partyType === 'coalition'
                ? partyColors.COL.light
                : partyColors.ALP.light,
        width: `${props.width}%`,
    }),
)

export const StyledSeatCountContainer = styled('div')(
    (props: { isRight?: boolean }) => ({
        display: 'none',
        alignItems: 'flex-end',
        justifyContent: props.isRight ? 'flex-start' : 'flex-end',
        [breakpoint('sm')]: {
            display: 'flex',
        },
    }),
)

export const StyledSeatCount = styled('span')(
    (props: { isRight?: boolean }) => ({
        fontSize: calcRem(64),
        fontWeight: 700,
        color: props.isRight
            ? partyColors.ALP.primary
            : partyColors.COL.primary,
        display: 'flex',
        alignItems: 'flex-end',
        whiteSpace: 'nowrap',
        lineHeight: calcRem(48),
        userSelect: 'none',
    }),
)

export const StyledPartyLabel = styled('span')(
    (props: { isRight?: boolean }) => ({
        position: 'absolute',
        ...(props.isRight ? { right: '0' } : { left: '0' }),
        bottom: calcRem(18),
        fontSize: calcRem(16),
        fontWeight: 600,
        color: props.isRight
            ? partyColors.ALP.primary
            : partyColors.COL.primary,
        userSelect: 'none',
        [breakpoint('sm')]: {
            fontSize: calcRem(20),
            bottom: calcRem(18),
        },
    }),
)

export const StyledPartyLabelSeatCount = styled('span')(
    (props: { isRight?: boolean }) => ({
        userSelect: 'none',
        [breakpoint('sm')]: {
            display: 'none',
        },
    }),
)

export const StyledCenterLine = styled('div')({
    position: 'absolute',
    left: '50%',
    height: '50%',
    borderLeft: `1px solid ${neutral[100]}`,
    bottom: calcRem(-2),
    zIndex: 9,
})

export const StyledCenterLabel = styled('span')({
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: 0,
    fontSize: calcRem(12),
    color: neutral[100],
    whiteSpace: 'nowrap',
    width: 'auto',
    userSelect: 'none',
})

export const StyledLoadingPlaceholder = styled('div')({
    width: '100%',
    height: calcRem(52),
    ...placeholderAnimation,
})

export const StyledSeatCountErrorContainer = styled('div')({
    height: calcRem(52),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    backgroundColor: neutral[10],
    borderRadius: calcRem(4),
    border: `${calcRem(1)} solid ${neutral[20]}`,
    flexDirection: 'row',
    gap: calcRem(8),
    wdith: '100%',
})

export const StyledSeatCountErrorText = styled('p')<{ isBold?: boolean }>(
    ({ theme, isBold = false }) => {
        return [
            textMixin<TheNightlyThemeConfig>(theme, 'body-alt'),
            {
                color: utility.error.default,
                margin: 0,
                fontWeight: isBold ? 700 : 400,
            },
        ]
    },
)
